







import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class ZoomControls extends Vue {

  @Prop() cloud: HTMLElement;

  get scaleCloud(): number {
    return this.$store.state.rhizome.scaleCloud;
  }

  set scaleCloud(value: number) {
    this.$store.commit('rhizome/setPropertyInState', { name: 'scaleCloud', value });
  }

  mounted() {
    window.addEventListener('mousewheel', this.scrollAction);
    window.addEventListener('DOMMouseScroll', this.scrollAction);
  }

  scrollAction(event) {
    let delta = 0;

    if (!event) event = window.event;
    if (event.wheelDelta) {
      delta = event.wheelDelta/120;
    }
    else if (event.detail) {
      delta = -event.detail/3;
    }

    this.zoomCloud(delta);
  }

  zoomCloud(delta: number) {
    if (delta) {
      if ((this.scaleCloud <= 0.2 && delta < 0) || (this.scaleCloud >= 1.5 && delta > 0)) return;

      let translate = this.cloud.style.transform.split(' ');
      let x = translate[0].replace('translate(', '').replace('px,', '');
      let y = translate[1].replace('px)', '');

      this.scaleCloud += delta * 0.1;
      this.cloud.style.transform = `translate(${x}px, ${y}px) scale(${this.scaleCloud})`;
    }
  }

  destroyed() {
    window.removeEventListener('mousewheel', this.scrollAction);
    window.removeEventListener('DOMMouseScroll', this.scrollAction);
  }
}
